import React from 'react';
import AppShell from './AppShell';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/proctor/dashboard' },
  { label: 'Messaging', path: '/proctor/messaging' },
];

const ProctorLayout = () => (
  <AppShell
    variant="navbar"
    chromeTone="dark"
    contentTone="light"
    navItems={NAV_ITEMS}
    roleLabel="PROCTOR"
  />
);

export default ProctorLayout;
